import React from 'react';
import { View, Text, Image, Pressable, StyleSheet } from 'react-native-web';
import Modal from 'react-modal';
import Button from './Button';
import blueLandscapeIcon from '../icons/blue-landscape-icon.png';

const ArchiveModal = ({ 
    isOpen, 
    onRequestClose, 
    item,
    itemType = "Campaign",
    imageUrlBase = "https://d3p3fw3rutb1if.cloudfront.net/business/photos/",
    onConfirm 
}) => {
    const getSubtext = (type) => {
        switch (type.toLowerCase()) {
            case 'd-roll':
            case 'droll':
                return "Archived D-Rolls can be restored later from your content settings.";
            case 'campaign':
            default:
                return "Archived campaigns can be restored later from your campaign settings.";
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={styles.modal}
            className="invite-modal"
        >
            <View style={styles.container}>
                <View style={styles.header}>
                    <Text style={styles.title}>Archive {itemType}</Text>
                    <Pressable
                        style={({ hovered }) => [
                            styles.closeButton,
                            hovered && styles.closeButtonHovered
                        ]}
                        onPress={onRequestClose}
                        accessible={true}
                        accessibilityLabel="Close modal"
                        accessibilityRole="button"
                    >
                        <Text style={styles.closeButtonText}>×</Text>
                    </Pressable>
                </View>
                <View style={styles.body}>
                    <Text style={styles.text}>
                        Are you sure you want to archive <Text style={styles.itemName}>{item?.name}</Text>?
                    </Text>
                    <Text style={styles.subtext}>
                        {getSubtext(itemType)}
                    </Text>
                    <View style={styles.imageContainer}>
                        <Image
                            style={styles.image}
                            source={item?.imageExists
                                ? {uri: imageUrlBase + item?.id}
                                : blueLandscapeIcon
                            }
                            defaultSource={blueLandscapeIcon}
                            resizeMode="cover"
                        />
                    </View>
                </View>
                <View style={styles.footer}>
                    <Button 
                        style={styles.cancelButton} 
                        text={"Cancel"} 
                        variant={"secondary"} 
                        onPress={onRequestClose} 
                    />
                    <Button 
                        style={styles.archiveButton} 
                        text={`Archive ${itemType}`} 
                        variant={"warning"} 
                        onPress={onConfirm} 
                    />
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modal: {
        overlay: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(57, 109, 224, .5)'
        },
        content: {
            margin: 'auto',
            maxWidth: '500px',
            maxHeight: '95vh',
            inset: 0,
            background: 'none',
            border: 'none',
            alignSelf: 'center',
            outline: 'none',
        }
    },
    container: {
        backgroundColor: 'white',
        borderRadius: 15,
        overflow: 'hidden',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 10 },
        shadowOpacity: 0.25,
        shadowRadius: 25,
        elevation: 5,
        minWidth: 450,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 25,
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
    },
    title: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 22,
        fontWeight: 'bold',
        color: '#111827',
    },
    closeButton: {
        padding: 8,
        borderRadius: 20,
        backgroundColor: '#f3f4f6',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        minWidth: 36,
        alignItems: 'center',
        justifyContent: 'center',
    },
    closeButtonHovered: {
        backgroundColor: '#e5e7eb',
        transform: [{ scale: 1.05 }],
    },
    closeButtonText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 20,
        fontWeight: 'bold',
        color: '#6b7280',
        lineHeight: 20,
    },
    body: {
        padding: 25,
        alignItems: 'center',
    },
    text: {
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        color: '#374151',
        marginBottom: 8,
        textAlign: 'center',
        lineHeight: 22,
    },
    itemName: {
        fontWeight: '600',
        color: '#396de0',
    },
    subtext: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        color: '#6b7280',
        marginBottom: 20,
        textAlign: 'center',
        lineHeight: 20,
    },
    imageContainer: {
        alignItems: 'center',
        marginBottom: 5,
    },
    image: {
        height: 120,
        width: 120,
        borderRadius: 12,
        backgroundColor: '#f3f4f6',
        borderWidth: 2,
        borderColor: '#e5e7eb',
    },
    footer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 25,
        borderTopWidth: 1,
        borderTopColor: '#e5e7eb',
        backgroundColor: '#f9fafb',
        gap: 15,
    },
    cancelButton: {
        flex: 1,
        minWidth: 120,
    },
    archiveButton: {
        flex: 1,
        minWidth: 140,
    },
});

export default ArchiveModal;